import {CanActivateChildFn, CanActivateFn, Router} from '@angular/router';
import {AuthService} from '../services/auth';
import {inject, PLATFORM_ID} from '@angular/core';
import {isPlatformServer} from '@angular/common';

export const authGuardGuard: CanActivateChildFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  // if (isPlatformServer(platformId)) return true;
  return authService.isLoggedIn()
    ? true
    : router.createUrlTree(['/login'], {
      queryParams: {returnUrl: state.url}
    });
};
export const loggedOut: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  // if (isPlatformServer(platformId)) return true;
  return !authService.isLoggedIn()
    ? true
    : router.createUrlTree(['/suggestions'], {});
};
